<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <h3 align="left">Uso de lentes:</h3>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-row dense>
      <v-col cols="3" sm="12" md="3" lg="3">
        <div class="text-subtitle-1">
          ¿El paciente necesita un uso de lentes?
        </div>
        <validation-provider
          v-slot="{ errors }"
          name="uso de lentes"
          rules="required"
        >
          <v-radio-group
            v-model="withGlasses"
            :disabled="isViewDetailsForm"
            :error-messages="errors"
          >
            <v-col cols="1" sm="12" md="1" lg="1">
              <v-radio
                label="Sí"
                :value="true"
                @click="setBaseGraduation()"
              ></v-radio>
            </v-col>
            <v-col cols="1" sm="12" md="1" lg="1">
              <v-radio
                label="No"
                :value="false"
                @click="clearModelGraduation()"
              ></v-radio>
            </v-col>
          </v-radio-group>
        </validation-provider>
      </v-col>
      <v-col v-if="withGlasses" justify="center" cols="9" sm="12" md="9" lg="9">
        <v-row>
          <v-col cols="4" sm="12" md="4" lg="4">
            <validation-provider
              v-slot="{ errors, touched, invalid }"
              name="Tipo de lente"
              rules="required"
            >
              <v-autocomplete
                label="Tipo de lente"
                :error-messages="errors"
                no-data-text="Sin resultados disponibles"
                :items="listGlasses"
                item-text="name"
                return-object
                clearable
                :clear-icon="$cnst.CLEAR_ICON"
                :disabled="isViewDetailsForm"
                v-model="model.glassesRequest.typeGlasses"
                ><v-icon
                  slot="append"
                  :color="touched && invalid ? 'error' : ''"
                >
                  {{ touched && invalid ? "mdi-alert" : "" }}
                </v-icon>
              </v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col
            cols="4"
            sm="12"
            md="4"
            lg="4"
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <validation-provider
              v-slot="{ errors, invalid, touched }"
              name="DIP (mm)"
              rules="required|doubleOrNumeric"
            >
              <v-text-field
                label="DIP (mm)"
                clearable
                :clear-icon="$cnst.CLEAR_ICON"
                :error-messages="errors"
                :disabled="isViewDetailsForm"
                v-model="model.glassesRequest.dip"
                ><v-icon
                  slot="append"
                  :color="touched && invalid ? 'error' : ''"
                >
                  {{ touched && invalid ? "mdi-alert" : "" }}
                </v-icon>
              </v-text-field></validation-provider
            >
          </v-col>
          <v-col
            cols="4"
            sm="12"
            md="4"
            lg="4"
            v-if="checkAddition()"
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <validation-provider
              v-slot="{ errors, invalid, touched }"
              name="Adición"
              rules="required|max:10"
            >
              <v-text-field
                label="Adición"
                clearable
                :clear-icon="$cnst.CLEAR_ICON"
                :error-messages="errors"
                v-model="model.glassesRequest.addition"
                :disabled="isViewDetailsForm"
                :counter="10"
                ><v-icon
                  slot="append"
                  :color="touched && invalid ? 'error' : ''"
                >
                  {{ touched && invalid ? "mdi-alert" : "" }}
                </v-icon>
              </v-text-field></validation-provider
            >
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <div class="text-subtitle-1">Graduación</div>
          </v-col>
          <v-col
            v-for="eye in model.glassesRequest.graduations"
            :key="eye.bodyPart.idBodyPart"
            cols="6"
            sm="12"
            md="6"
            lg="6"
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <validation-provider
              v-slot="{ errors, touched, invalid }"
              :name="eye.bodyPart.name"
              rules="required|max:20"
            >
              <v-text-field
                clearable
                :clear-icon="$cnst.CLEAR_ICON"
                required
                :error-messages="errors"
                v-model="eye.graduate"
                :label="eye.bodyPart.name"
                :disabled="isViewDetailsForm"
                :counter="20"
                ><v-icon
                  slot="append"
                  :color="touched && invalid ? 'error' : ''"
                >
                  {{ touched && invalid ? "mdi-alert" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { OptometryComponentService } from "@/app/services";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  props: {
    model: Object,
    clearGraduation: Object,
    isViewDetailsForm: Boolean,
    toUpdateTable: Boolean,
  },
  components: {
    ValidationProvider,
  },
  data() {
    return {
      listGlasses: [],
      withGlasses: null,
      modelStatic: {},
    };
  },
  mounted() {
    this.listAll();
    if (this.toUpdateTable) {
      this.openGlasses();
    }
  },
  methods: {
    listAll() {
      OptometryComponentService.optometryGlassesType().then((res) => {
        this.listGlasses = res.data;
      });
    },
    openGlasses() {
      this.withGlasses =
        !!this.model?.glassesRequest?.idGlassesRequest ||
        !!this.model?.glassesRequest;
      // if (
      //   this.model?.glassesRequest?.idGlassesRequest != undefined ||
      //   this.model?.glassesRequest != null
      // ) {
      //   this.withGlasses = true;
      // } else {
      //   this.withGlasses = false;
      // }

      // this.withGlasses =
      //   "idGlassesRequest" in this.model?.glassesRequest ||
      //   this.model?.glassesRequest != null;
    },
    clearModelGraduation() {
      this.model.glassesRequest = null;
    },
    setBaseGraduation() {
      this.model.glassesRequest = this.clearGraduation;
    },
    checkAddition() {
      if (
        this.model?.glassesRequest == null ||
        this.model?.glassesRequest?.typeGlasses == null ||
        this.model?.glassesRequest?.typeGlasses?.requireAddition == null
      ) {
        return false;
      }
      return this.model.glassesRequest.typeGlasses.requireAddition === 1;
    },
  },
};
</script>
<style></style>
